import api from '@components/api';

const formatProzessdatum = date => {
  date.toISOString();
  const viennaTimezone = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Vienna',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(new Date(date));

  const [day, month, year, time] = viennaTimezone.match(/\d+/g);

  return `${year}-${month}-${day}T${time}:00:00Z`;
};

// TARIFBERATER API REQUEST
// Primary Way to fetch data from the platform
const fetchData = async (productType, values) => {
  // API preparation
  const params = {
    type: productType,
  };

  const {
    product,
    usage,
    zipcode,
    defaultAktion,
    prozessdatum,
    options,
    ecoMode,
    priceGuarantee,
    nobindung,
    isSpotProduct,
  } = values;

  if (product) {
    params.product = product;
  }

  if (zipcode && usage) {
    params.kwh = usage;
    params.plz = zipcode;
  }

  if (isSpotProduct && zipcode) {
    params.plz = zipcode;
  }

  if (ecoMode) {
    params.oko = 1;
  }

  if (priceGuarantee) {
    params.price = 1;
  }

  if (nobindung) {
    params.nobindung = 1;
  }

  let code = '';
  if (options) {
    // array from product category
    if (Array.isArray(options) && options.length) {
      // Options
      params.options = options
        .map(
          ({ key, mixtype, bindung, capprice }) =>
            `${key}-${mixtype}-${bindung}${capprice ? `-${capprice}` : ``}`,
        )
        .join('|');
      // Aktion Code
      code = values?.options?.filter(value => value?.aktionsCode !== '')[0]
        ?.aktionsCode;
      // object from product detail page
    } else if (
      typeof options === 'object' &&
      options !== null &&
      !Array.isArray(options)
    ) {
      // Options
      params.options = [
        options?.key,
        options?.mixtype,
        options?.bindung,
        options?.capprice,
      ]
        .filter(item => !!item)
        .join('-');
      // Aktion Code
      if (options?.aktionsCode) {
        code = options?.aktionsCode;
      }
    }
  }

  if (code?.length > 0) {
    params.aktion = code;
  } else {
    params.aktion = defaultAktion;
  }

  if (options?.prozessdatum) {
    params.prozessdatum = formatProzessdatum(options.prozessdatum);
  } else if (prozessdatum) {
    params.prozessdatum = formatProzessdatum(prozessdatum);
  }

  try {
    const { data: response } = await api.get(`/tarife/tarifberater`, {
      timeout: 5000,
      params,
    });

    return response;
  } catch (error) {
    throw new Error(error.response.data.data.msg);
  }
};

export default fetchData;
